import {
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridColumnProps,
} from "@progress/kendo-react-grid";
//import styles from "styles.module.css";
import i18n from "../../../../i18n";
import { CustomColumnMenuSearchFilterUI } from "ui/grid/filter/SearchFilter";
import React from "react";

let t = i18n.t;

export interface UserListDynamicColumn {
  field: string;
  title: string;
  hidden: boolean;
}

export interface UserListDynamicColumns {
  buyers: UserListDynamicColumn;
  vessels: UserListDynamicColumn;
  terminals: UserListDynamicColumn;
}

const splitMultiValue = (value?: string | null) => {
  if (!value) {
    return [];
  }

  return value
    .split("<br/>")
    .map((item) => item.trim())
    .filter(Boolean);
};

const CustomSplitCell = (props: any) => {
  const value = props.dataItem?.[props.field];
  const splittedString = splitMultiValue(value);

  if (splittedString.length === 0) {
    return <td {...props.tdProps} />;
  }

  return (
    <td {...props.tdProps}>
      {" "}
      {splittedString.map((item: string, index: number) => {
        return (
          <span key={index}>
            {item}
            <br />
          </span>
        );
      })}
    </td>
  );
};

const openDropdown = (e: any) => {
  e.preventDefault();
};

export const UserListGridColumns = (props: {
  ref: React.RefObject<HTMLDivElement>;
  roles: any[];
  deleteUser: (data: any) => void;
  dynamicColumns: UserListDynamicColumns;
  setDynamicColumns: React.Dispatch<
    React.SetStateAction<UserListDynamicColumns>
  >;
}): GridColumnProps[] => {
  const toggleColumnVisibility = (columnKey: string) => {
    props.setDynamicColumns((prev) => ({
      ...prev,
      [columnKey]: {
        ...prev[columnKey as keyof typeof prev],
        hidden: !prev[columnKey as keyof typeof prev].hidden,
      },
    }));
  };

  const ColumnVisibilityMenu = () => (
    <div style={{ padding: "10px", minWidth: "200px" }}>
      <div
        style={{ marginBottom: "8px", fontWeight: "bold", fontSize: "14px" }}
      >
        {t("Show")}/ {t("Hide")} {t("Columns")}
      </div>
      {Object.entries(props.dynamicColumns).map(([key, column]) => (
        <div
          key={key}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "6px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            id={`column-${key}`}
            checked={!column.hidden}
            onChange={() => toggleColumnVisibility(key)}
            style={{ marginRight: "8px" }}
          />
          <label
            htmlFor={`column-${key}`}
            style={{
              cursor: "pointer",
              fontSize: "13px",
              userSelect: "none",
            }}
          >
            {column.title}
          </label>
        </div>
      ))}
    </div>
  );

  const gridItems: GridColumnProps[] = [
    {
      field: "",
      width: "30px",

      columnMenu: (props) => <ColumnVisibilityMenu />,
    },
    {
      field: "firstname",
      title: t("Firstname"),
      //width: "60px",
      filter: "text",
      filterable: false,

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter
      // 		{...props}
      // 		expanded={true}
      // 		filterUI={CustomColumnMenuSearchFilterUI}
      // 	/>
      // ),
    },
    {
      field: "lastname",
      title: t("Lastname"),
      //width: "150px",
      headerClassName: "no-border",
      filterable: false,

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter
      // 		{...props}
      // 		expanded={true}
      // 		filterUI={CustomColumnMenuSearchFilterUI}
      // 	/>
      // ),

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter {...props} expanded={true} />
      // ),
    },
    {
      field: "email",
      title: t("Email"),
      //width: "150px",
      headerClassName: "no-border",
      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter {...props} expanded={true} />
      // ),

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter
      // 		{...props}
      // 		expanded={true}
      // 		filterUI={CustomColumnMenuSearchFilterUI}
      // 	/>
      // ),
    },
    {
      field: "roles",
      title: t("Roles"),
      width: "200px",
      filter: "text",
      sortable: false,

      // columnMenu: (prop) => (
      // 	<ColumnMenuCheckboxFilter {...prop} data={props.roles} />
      // ),
      cells: {
        data: CustomSplitCell,
      },
      headerClassName: "no-border",
    },
    {
      field: "buyers",
      title: props.dynamicColumns.buyers.title,
      hidden: props.dynamicColumns.buyers.hidden,
      //width: "150px",
      cells: {
        data: CustomSplitCell,
      },
      headerClassName: "no-border",
      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter {...props} expanded={true} />
      // ),
    },
    {
      field: "vessels",
      title: props.dynamicColumns.vessels.title,
      hidden: props.dynamicColumns.vessels.hidden,
      //width: "150px",
      cells: {
        data: CustomSplitCell,
      },
      headerClassName: "no-border",
      // columnMenu: (prop) => (
      // 	<ColumnMenuCheckboxFilter {...prop} data={props.data} />
      // ),
    },
    {
      field: "terminals",
      title: props.dynamicColumns.terminals.title,
      hidden: props.dynamicColumns.terminals.hidden,
      sortable: false,

      //width: "150px",
      cells: {
        data: CustomSplitCell,
      },
      headerClassName: "no-border",
      // columnMenu: (prop) => (
      // 	<ColumnMenuCheckboxFilter {...prop} data={props.data} />
      // ),
    },
    // {
    // 	field: "",
    // 	title: "",
    // 	width: "100px",
    // 	cells: {
    // 		data: (prop) => (
    // 			<td
    // 				style={{
    // 					display: "flex",
    // 					justifyContent: "flex-end",
    // 					paddingRight: "10px",
    // 				}}
    // 			>
    // 				<div style={{ display: "flex", gap: "10px" }}>
    // 					<TextButton
    // 						onClick={() => {
    // 							window.open(
    // 								`/${PageTypePath.UserInformation}/${prop.dataItem.id}`,
    // 								"_blank"
    // 							);
    // 						}}
    // 						text={""}
    // 						iconName={ICON_NAMES.Edit}
    // 					/>
    // 					<TextButton
    // 						onClick={() => {
    // 							props.deleteUser(prop.dataItem);
    // 						}}
    // 						text={""}
    // 						iconName={ICON_NAMES.Delete}
    // 					/>
    // 				</div>
    // 			</td>
    // 		),
    // 	},
    // },
  ];
  return gridItems;
};

export const OldUserGridColumns = (): GridColumnProps[] => {
  // const toggleColumnVisibility = (columnKey: string) => {
  // 	props.setDynamicColumns((prev) => ({
  // 		...prev,
  // 		[columnKey]: {
  // 			...prev[columnKey as keyof typeof prev],
  // 			hidden: !prev[columnKey as keyof typeof prev].hidden,
  // 		},
  // 	}));
  // };

  //   const ColumnVisibilityMenu = () => (
  //     <div style={{ padding: "10px", minWidth: "200px" }}>
  //       <div
  //         style={{ marginBottom: "8px", fontWeight: "bold", fontSize: "14px" }}
  //       >
  //         {t("Show")}/ {t("Hide")} {t("Columns")}
  //       </div>
  //       {Object.entries(props.dynamicColumns).map(([key, column]) => (
  //         <div
  //           key={key}
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             marginBottom: "6px",
  //             cursor: "pointer",
  //           }}
  //         >
  //           <input
  //             type="checkbox"
  //             id={`column-${key}`}
  //             checked={!column.hidden}
  //             onChange={() => toggleColumnVisibility(key)}
  //             style={{ marginRight: "8px" }}
  //           />
  //           <label
  //             htmlFor={`column-${key}`}
  //             style={{
  //               cursor: "pointer",
  //               fontSize: "13px",
  //               userSelect: "none",
  //             }}
  //           >
  //             {column.title}
  //           </label>
  //         </div>
  //       ))}
  //     </div>
  //   );

  const gridItems: GridColumnProps[] = [
    // {
    // 	field: "",
    // 	width: "30px",

    // 	columnMenu: (props) => <ColumnVisibilityMenu />,
    // },
    {
      field: "firstname",
      title: t("Firstname"),
      //width: "60px",
      filter: "text",
      filterable: false,

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter
      // 		{...props}
      // 		expanded={true}
      // 		filterUI={CustomColumnMenuSearchFilterUI}
      // 	/>
      // ),
    },
    {
      field: "lastname",
      title: t("Lastname"),
      //width: "150px",
      headerClassName: "no-border",
      filterable: false,

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter
      // 		{...props}
      // 		expanded={true}
      // 		filterUI={CustomColumnMenuSearchFilterUI}
      // 	/>
      // ),

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter {...props} expanded={true} />
      // ),
    },
    {
      field: "email",
      title: t("Email"),
      //width: "150px",
      headerClassName: "no-border",
      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter {...props} expanded={true} />
      // ),

      // columnMenu: (props) => (
      // 	<GridColumnMenuFilter
      // 		{...props}
      // 		expanded={true}
      // 		filterUI={CustomColumnMenuSearchFilterUI}
      // 	/>
      // ),
    },
    {
      field: "roles",
      title: t("Roles"),
      width: "200px",
      filter: "text",
      sortable: false,

      // columnMenu: (prop) => (
      // 	<ColumnMenuCheckboxFilter {...prop} data={props.roles} />
      // ),
      cells: {
        data: CustomSplitCell,
      },
      headerClassName: "no-border",
    },
  ];
  return gridItems;
};

const ColumnMenuCheckboxFilter = (
  props: GridColumnMenuProps & { data: any[] },
) => {
  return (
    <div>
      <GridColumnMenuCheckboxFilter
        {...props}
        expanded={true}
        data={props.data}
      />
    </div>
  );
};
